// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vendor-master-main-flex-column-wrapper{display:flex;width:100%}.vendor-master-main-flex-column-wrapper>div{padding:0 10px}.vendor-master-main-flex-column-wrapper.two-column-wrapper>div{flex-basis:50%;max-width:50%}.vendor-master-main-flex-column-wrapper.three-column-wrapper>div{flex-basis:33%;max-width:33%}\n", ""]);
// Exports
module.exports = exports;
